<template>
  <h1>Create new garment type</h1>
  <div id="garmenttype-editor content-section">
    <div class="page-section">
      <div v-if="success">
        <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-success">Garment updated</div>
      </div>

      <div v-if="errorMessage">
        <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-danger">
          An error occurred trying to save the garment: {{ errorMessage }}
        </div>
      </div>

      <div class="row">
        <div class="col-md-8">
          <FormKit
              type="form"
              id="edit-garment"
              submit-label="New garment type"
              :actions="false"
              @submit="saveGarmentType"
          >
            <FormKit
                v-model="garmenttype.garmenttype"
                type="text"
                name="garmenttype"
                id="garmenttype"
                label="Unique Garment Type"
                help="Garment type name (customer)"
                placeholder="garment type name"
            />

            <FormKit
                type="submit"
                label="Save"
                outer-class="half"
                input-class="$reset btn btn-primary"
            />

          </FormKit>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue'
import { useRouter } from 'vue-router'
import GarmentTypeService from "@/services/GarmentTypeService";

const router = useRouter();
const success = ref(false);
const errorMessage = ref("");

const garmenttype = ref({
  id: 0,
  garmenttype: "",
  priority: 9999,
  isActive: 0,
});

const saveGarmentType = async () => {

  let formData = {
    garmenttype: garmenttype.value.garmenttype,
  }

  GarmentTypeService.createGarmentType(formData)
      .then(response => {
        success.value = true;
        router.push('/garmenttype/' + response.data.data.garment_type.garmenttypeid);
      })
      .catch(e => {
        console.log(e.response);
        errorMessage.value = e.response.data.message;
      });
}


</script>

<style scoped>

</style>